import {NonEmbeddedPendingComponent} from "~/components/routerHelpers/nonEmbeddedPendingComponent";
import {Route} from "./route";

export function PendingComponent() {
    return (
        <NonEmbeddedPendingComponent
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
        //
        />
    );
}
